import { Component, OnInit, Input } from '@angular/core';
import { PassengerModel } from '../../core/models/passenger-model';

@Component({
  selector: 'check-in-passenger-type-display',
  templateUrl: './passenger-type-display.component.html',
  styleUrls: ['./passenger-type-display.component.scss']
})
export class PassengerTypeDisplayComponent implements OnInit {

  @Input() passenger: PassengerModel;
  @Input() cssClass: string;

  constructor() { }

  ngOnInit() {
  }

}
